import * as actionTypes from "./actionTypes";

const initialState = {
  contactDetails: null,
  done: false,
};

const contactReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.sendContactDetails:
  
      return {
        ...state,
        contactDetails: action.payload,
      };
    default:
      return initialState;
  }
};

export default contactReducer;
